import {create} from "zustand";
import {DiaryRequestParams, DiaryResponse, DiaryState} from "./types";
import {$api} from "shared/api";
import {DiaryEntry} from "shared/types";
import {serializeParams} from "shared/helpers/converters";
import {toast} from "react-toastify";

export const useDiaryStore = create<DiaryState>((set, get) => ({
  isLoading: false,
  entries: [],
  customFields: [],
  customFieldsCols: [],
  currentPage: 0,
  pageSize: 10,
  isEnd: false,
  lastParams: null,
  isNewEntrieOpen: false,

  // START
  getDiaryEntriesFromServer: async (params, setLast = true) => {
    const paramsClone =
      structuredClone?.(params) || JSON.parse(JSON.stringify(params));
    const { pageSize } = get();

    if (setLast) {
      set({
        lastParams: paramsClone,
      });
    }

    const keys = Object.keys(paramsClone) as (keyof DiaryRequestParams)[];
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      const value = paramsClone[key];
      
      if (Array.isArray(value)) {
        if (value.length === 0) {
          delete paramsClone[key];
        }
      } else if (!value) {
        delete paramsClone[key];
      }
    }

    if (!paramsClone.page) {
      paramsClone.page = {
        index: 0,
        size: pageSize,
      };
    }

    const path = `/diaries/`;
    const res = await $api.get<DiaryResponse>(path, {
      params: paramsClone,
      paramsSerializer: { serialize: serializeParams },
    });

    const entriesGetted = res?.data?.items ?? [];
    const pagination = res?.data?.pagination;
    const total = res?.data?.total;

    set({
      entries: entriesGetted,
      currentPage: paramsClone.page?.index || 0,
      isEnd:
        entriesGetted.length < pageSize ||
        (pagination && total <= (pagination.index + 1) * pagination.size),
    });
  },


  activeDateFilter: false,
  setActiveDateFilter: (value: boolean) => set({ activeDateFilter: value }),
  clearEntries: () =>
    set({
      entries: [],
      currentPage: 0,
      isEnd: false,
      lastParams: null,
    }),
  getNextPage: async () => {
    const path = `/diaries/`;
    const { lastParams, entries, currentPage, pageSize, isEnd, isLoading } = get();

    // Проверяем, есть ли еще данные для загрузки
    if (!lastParams || isEnd || isLoading) return;

    const paramsClone =
      structuredClone?.(lastParams) || JSON.parse(JSON.stringify(lastParams));

    // Устанавливаем следующую страницу
    paramsClone.page = {
      index: currentPage + 1,
      size: pageSize,
    };

    try {
      const res = await $api.get<DiaryResponse>(path, {
        params: paramsClone,
        paramsSerializer: { serialize: serializeParams },
      });

      const entriesGetted = res?.data?.items ?? [];
      const pagination = res?.data?.pagination;
      const total = res?.data?.total;
      // Если нет новых записей - достигаем конца
      if (entriesGetted.length === 0) {
        set({ isEnd: true });
        return;
      }

      // Добавляем новые записи к существующим
      set({
        currentPage: currentPage + 1,
        entries: [...entries, ...entriesGetted],
      });

      // Проверяем, достигли ли мы конца
      if (pagination && total) {
        const itemsCount = (pagination.index + 1) * pagination.size;
        if (total <= itemsCount || entriesGetted.length < pageSize) {
          set({ isEnd: true });
        }
      } else {
        // Fallback если нет пагинации
        if (entriesGetted.length < pageSize) {
          set({ isEnd: true });
        }
      }
    } catch (error) {
      console.error("Error loading next page:", error);
      toast.error("Ошибка при загрузке следующей страницы");
    }
  },
  getDiaryEntries: () => {
    const { entries } = get();
    return entries;
  },

  addEntry: async (params) => {
    console.log("Adding entry with params:", params);
    const res = await $api.post<DiaryEntry>("/diaries", params);
    return res;
  },

  editEntry: async (params) => {
    const res = await $api.put(`/diaries/${params.id}`, params);
    return res;
  },
  setCurrentPage: (page) => {
    set({ currentPage: page });
  },
  setCustomFields(value) {
    set({ customFields: value });
  },
  setCustomFieldsCols(value) {
    set({ customFieldsCols: value });
  },
  setIsEnd: (val) => {
    set({ isEnd: val });
  },
  setIsNewEntrieOpen: (val) => {
    set({ isNewEntrieOpen: val });
  },
  exportTable: async (apiaryId) => {

    const res = await $api
      .get(`/diaries/${apiaryId}/export`, { responseType: "blob" })
      .catch((err) => {
        toast.error(
          err.response.data.message ||
            "Произошла ошибка, попробуйте позже, пожалуйста"
        );
      });

    if (!res) return;

    const blob = new Blob([res.data], {
      type: res.headers["content-type"] ?? "text/xlsx",
    });

    return blob;
  },
}));
